import {Hub, isTaskWithoutPermissions} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {globals} from '@extensions/globals-base'

export const canShowTask = (task: Hub): boolean => {
  return (
    !isTaskWithoutPermissions(task) &&
    PermissionsChecker.checkShow('ignore-departments', task, {
      considerAsMy: true,
      considerAsWithMe: true,
      userId: globals.currentUserId,
      ignoreAdmin: false
    })
  )
}
